module.exports = __webpack_public_path__ + "img/home1-3.e4133c97.jpg";